var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24145 8.58225L5.58444 4.92525C5.51136 4.8587 5.45237 4.77815 5.41096 4.68839C5.36956 4.59862 5.34659 4.50147 5.3434 4.40267C5.34022 4.30387 5.35689 4.20543 5.39242 4.11319C5.42796 4.02095 5.48164 3.93677 5.55029 3.86565C5.61894 3.79452 5.70116 3.73789 5.79209 3.69911C5.88302 3.66033 5.9808 3.64018 6.07965 3.63987C6.1785 3.63955 6.27641 3.65907 6.36759 3.69727C6.45876 3.73547 6.54134 3.79157 6.61044 3.86225L6.62844 3.88025L10.8084 8.05925C10.947 8.19784 11.0248 8.38578 11.0248 8.58175C11.0248 8.77772 10.947 8.96567 10.8084 9.10425L6.62945 13.2833C6.56201 13.3531 6.48149 13.4089 6.39248 13.4476C6.30347 13.4862 6.20771 13.507 6.11067 13.5087C6.01364 13.5104 5.91722 13.4929 5.82693 13.4573C5.73664 13.4217 5.65424 13.3687 5.58445 13.3013C5.51465 13.2338 5.45882 13.1533 5.42014 13.0643C5.38146 12.9753 5.36069 12.8795 5.35902 12.7825C5.35735 12.6854 5.37481 12.589 5.4104 12.4987C5.44599 12.4084 5.49901 12.3261 5.56645 12.2563L5.58445 12.2383L9.24145 8.58225Z",
    fill: "#DAC6E1",
    stroke: "#DAC6E1",
    strokeWidth: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4e93645925cc42024225e19da92d25ee.svg";
export { ForwardRef as ReactComponent };